var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 64,
    viewBox: "0 0 41 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0305 50.5311H0.587891V42.0224L15.5493 6.57178H28.24V42.2351H33.8423V50.5311H28.24V64.0021H18.0305V50.5311ZM18.0305 42.2329V17.8444L9.23688 42.2329H18.0305Z",
    fill: "#8DC73F",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7231 59.6053H23.5135C22.914 59.6053 22.425 59.1185 22.425 58.5168V46.1343H6.07099C5.47143 46.1343 4.98242 45.6475 4.98242 45.0458V36.5371C4.98242 36.3925 5.01219 36.248 5.06747 36.114L20.031 0.663345C20.2011 0.261511 20.5965 0 21.0345 0H33.7252C34.3248 0 34.8138 0.486878 34.8138 1.08857V35.6633H39.3275C39.9271 35.6633 40.4161 36.1523 40.4161 36.7518V45.0479C40.4161 45.6475 39.9292 46.1365 39.3275 46.1365H34.8138V58.5189C34.8138 59.1185 34.3269 59.6075 33.7252 59.6075L33.7231 59.6053ZM24.6021 57.4303H32.6345V45.0479C32.6345 44.4483 33.1214 43.9593 33.7231 43.9593H38.2368V37.8383H33.7231C33.1235 37.8383 32.6345 37.3514 32.6345 36.7497V2.175H21.7553L7.15955 36.7582V43.9593H23.5135C24.1131 43.9593 24.6021 44.4483 24.6021 45.0479V57.4303ZM23.5135 37.8383H14.72C14.3649 37.8383 14.0332 37.6661 13.8291 37.3748C13.625 37.0856 13.5761 36.7157 13.6973 36.3798L22.4909 11.9912C22.6695 11.4958 23.1861 11.2046 23.7006 11.2896C24.2215 11.381 24.6021 11.8318 24.6021 12.3612V36.7497C24.6021 37.3493 24.1152 37.8383 23.5135 37.8383ZM16.2699 35.6612H22.4271V18.5864L16.2699 35.6612Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8241,
    height: 64,
    fill: "white",
    transform: "translate(0.587891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.2f980cf7747c633359a6cb18cb1b0f1c.svg";
export { ForwardRef as ReactComponent };